import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import useApi from "../../hooks/useApi";
import { verifyEmail } from "../../api/FlaskAPI";
import Loading from "../../components/Buttons/Loading";
import "./styles.css";


const MailIcon = () => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="5" width="18" height="14" rx="2" stroke="var(--primary-dark, #355e7e)"
            strokeWidth="1.5" fill="none" />
        <path d="M3 7l9 5 9-5" stroke="var(--primary-dark, #355e7e)" strokeWidth="1.5"
            strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const SuccessIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" fill="#4caf50" />
        <path d="M8 12.5l2.5 2.5L16 9.5" stroke="white" strokeWidth="2"
            strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const ErrorIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" fill="#f44336" />
        <path d="M15 9l-6 6M9 9l6 6" stroke="white" strokeWidth="2"
            strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);


function EmailVerification() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { token } = useParams();
    const verifyRequest = useApi(verifyEmail);
    const [status, setStatus] = useState("verifying"); // verifying | success | error
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (token) {
            handleVerification(token);
        } else {
            setStatus("error");
            setErrorMessage(t("Sign.invalid_token"));
        }
    }, []);

    const handleVerification = async (token) => {
        const res = await verifyRequest.request({ token }, false);

        if (res?.status === 200) {
            setStatus("success");
            toast.success(t("Sign.verification_success"));
            setTimeout(() => navigate("/"), 3000);
        } else {
            setStatus("error");
            setErrorMessage(res?.data?.message || t("Sign.verification_failed"));
            toast.error(res?.data?.message || t("Sign.verification_failed"));
        }
    };

    return (
        <div className="verify-page">
            <div className="verify-card">
                {/* VERIFYING STATE */}
                {status === "verifying" && (
                    <>
                        <div className="verify-icon">
                            <MailIcon />
                        </div>
                        <h2 className="verify-title">{t("Sign.verifying_email")}</h2>
                        <Loading />
                    </>
                )}

                {/* SUCCESS STATE */}
                {status === "success" && (
                    <>
                        <div className="status-badge">
                            <SuccessIcon />
                        </div>
                        <h2 className="verify-title">{t("Sign.verification_success")}</h2>
                        <p className="verify-subtitle">{t("Sign.redirecting_to_login")}</p>
                    </>
                )}

                {/* ERROR STATE */}
                {status === "error" && (
                    <>
                        <div className="status-badge">
                            <ErrorIcon />
                        </div>
                        <h2 className="verify-title">{t("Sign.verification_failed")}</h2>
                        <p className="verify-subtitle error-text">{errorMessage}</p>
                        <button className="verify-btn primary" onClick={() => navigate("/")}>
                            {t("Sign.return")}
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}

export default EmailVerification;
